import React from 'react';
import ImageWithCache from './ImageWithCache';
import './MarketPage.css';

const MarketPage = () => {
  return (
    <div className="market-page">
      <ImageWithCache className="market-bg" src="/market-icons/mono-market.webp" alt="monoмаркет" />
    </div>
  );
};

export default MarketPage;
